import * as React from 'react';

const SVGArrowNav: React.SFC<SvgProps> = props => (
    <svg width={10} height={6} {...props}>
        <path
            d="M1 1.076L5.158 5.25 9.408 1"
            fillRule="nonzero"
            strokeWidth={1.2}
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SVGArrowNav;
